import React, { useState } from 'react';
import { List, ListItemButton, ListItemText, Divider, ListItemAvatar, CardMedia, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { SymbolTypography } from 'components/ManaSymbol';
import { Card, CardResult } from 'api/card';
import CardDetail from './CardDetail';

type Props = {
  cardResult: CardResult,
};

const ListView: React.FC<Props> = React.memo(
  ({ cardResult }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [selectedCard, setSelectedCard] = useState<Card>();

    return (
      <List>
        {cardResult.cards.map(card => (
          <>
            <ListItemButton
              key={card.id}
              onClick={() => {
                setSelectedCard(card);
                setOpen(true);
              }}
            >
              <ListItemAvatar sx={{ paddingRight: 1, maxWidth: '20%' }}>
                <CardMedia component='img' src={card.image_url_small} sx={{ maxHeight: 100 }} />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <SymbolTypography text={`${card.ja_name} / ${card.original_name} ${card.mana_cost}`} variant='body1' />
                }
                secondary={
                  card.layout === 'normal'
                    ? (
                      <React.Fragment>
                        <Typography variant='subtitle2' sx={{ marginBottom: 0.5 }}>
                          {card.ja_type_line}
                        </Typography>
                        <SymbolTypography text={card.ja_text} variant='body2' />
                        {card.power !== '' ? `${card.power}/${card.toughness}` : ''}
                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        <Typography variant='subtitle2' sx={{ marginBottom: 0.5 }}>
                          {card.card_faces?.face1.ja_type_line}
                        </Typography>
                        <SymbolTypography text={card.card_faces?.face1.ja_text ?? ''} variant='body2' />
                        <Divider sx={{ borderColor: grey[300] }} />
                        <Typography variant='subtitle2' sx={{ marginY: 0.5 }}>
                          {card.card_faces?.face2.ja_type_line}
                        </Typography>
                        <SymbolTypography text={card.card_faces?.face2.ja_text ?? ''} variant='body2' />
                      </React.Fragment>
                    )
                }
              />
            </ListItemButton>
            <Divider variant='fullWidth' component='li' />
          </>
        ))}
        <CardDetail card={selectedCard} open={open} onClose={() => setOpen(false)} />
      </List>
    );
  }
);

export default ListView
